import React, { useState, useEffect } from 'react';
import { Button } from './Button';
import { Link } from 'react-router-dom';
import './Navbar.css';
import { motion } from 'framer-motion';

function Navbar() {
  const [click, setClick] = useState(false);
  const [button, setButton] = useState(true);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  const showButton = () => {
    if (window.innerWidth <= 960) {
      setButton(false);
    } else {
      setButton(true);
    }
  };

  useEffect(() => {
    showButton();
  }, []);

  window.addEventListener('resize', showButton);

  return (
    <>
      <nav className='navbar'>
        <div className='navbar-container'>
          <Link
            to='/' className='navbar-logo' onClick={closeMobileMenu} >
            TK
            <i className='fab fa-typo3' />
          </Link>
          <motion.li className='nav-item' initial={{ opacity: 0, translateX: -30, translateY: -30 }}
            whileInView={{ opacity: 1, translateX: 0, translateY: 0 }}
            viewport={{ once: false, amount: 0.5 }}
            transition={{ duration: 0.5, delay: 0.4 }}>
            <a
              class="button-rotating Resume "
              onClick={closeMobileMenu} href="/files/resume.pdf" download>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              RESUME

            </a>

          </motion.li>

        </div>
      </nav>
    </>
  );
}

export default Navbar;